import { OnProgressBizLineDesc, RewardType } from '../types/rewardRecords';
import { formatFloat } from './number';
import { ActivityStatus } from '../types/shared';
export function resolveActivityViewModel(rawInfoRes) {
    try {
        const moduleInfo = rawInfoRes?.moduleInfoList?.[0];
        const cardModule = moduleInfo?.cardModuleInfoVO;
        const rankModule = moduleInfo?.rankModuleInfo;
        const selectedGroups = cardModule?.selectedCardGroups || [];
        const cardGroups = cardModule?.cardGroupInfos || [];
        const currentGroupKey = selectedGroups[0];
        const currentGroup = currentGroupKey ? cardGroups?.find(g => g?.groupKey === String(currentGroupKey)) : undefined;
        const landmarks = resolveLandmarks(currentGroup);
        const currentCityName = currentGroup?.groupName ?? '';
        // 分数
        const currentScore = formatFloat(rankModule?.curTeamInfo?.teamScoreDouble ?? rankModule?.curTeamInfo?.teamScore ?? 0);
        const totalScore = formatFloat(rankModule?.upperLimit ?? 0);
        const startTime = rankModule?.startTime ?? 0;
        const endTime = rankModule?.endTime ?? 0;
        return {
            currentCityId: currentGroup?.groupKey,
            currentCityName,
            totalScore,
            currentScore,
            landmarks,
            startTime,
            endTime
        };
    }
    catch (error) {
        return {};
    }
}
function resolveLandmarks(group) {
    if (!group)
        return [];
    const stepRewards = group?.cards?.map((card, index) => {
        // 从卡片组信息中提取每个地标对应需要的分数
        // score threshold comes from stepRewardInfos ordering
        let cardExtra = {};
        try {
            cardExtra = JSON.parse(card.cardExtra || '{}');
        }
        catch (error) { }
        return {
            cardId: card.cardId,
            name: card.cardName,
            description: card.cardDesc,
            cover: card.cardImage,
            icon: card.cardImage,
            obtained: card.obtained,
            sortOrder: card.sortOrder,
            cardExtra
        };
    });
    return stepRewards.sort((a, b) => {
        // obtained 为 true 的排在前面
        if (a.obtained !== b.obtained)
            return a.obtained ? -1 : 1;
        // 相同 obtained 状态下按 sortOrder 排序
        return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
    });
}
export function resolveFreeCard(rawRewardRes) {
    if (!rawRewardRes)
        return undefined;
    const reward = rawRewardRes?.rewardItems?.find(item => item.rewardType === RewardType.FREE_CARD);
    if (!reward)
        return undefined;
    return reward;
}
// R003：判断免单卡是否已使用（bindOrderId 不为空则视为已使用）
export function checkIsHaveFreeCardUsed(rawRewardRes) {
    try {
        const reward = resolveFreeCard(rawRewardRes);
        if (!reward?.extra)
            return false;
        const extra = JSON.parse(reward.extra);
        return !!extra?.freeOrderCardExtra?.bindOrderId;
    }
    catch {
        return false;
    }
}
// 业务线枚举值 → 展示名称映射（来自真实接口 canBindBizLines 字段）
const BIZ_LINE_DISPLAY_NAME = {
    1: '酒店',
    4: '火车票',
    5: '机票目的地'
};
/**
 * 将两个文本列表交替合并：[a0, b0, a1, b1, ...]
 * 数量不等时各自循环补齐；两者都为空返回空数组。
 */
function mergeItems(listA, listB) {
    if (listA.length === 0 && listB.length === 0)
        return [];
    if (listA.length === 0)
        return listB;
    if (listB.length === 0)
        return listA;
    const count = Math.max(listA.length, listB.length);
    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(listA[i % listA.length]);
        result.push(listB[i % listB.length]);
    }
    return result;
}
/**
 * 按活动状态分支决定最终轮播文案列表（纯函数，无副作用）。
 * - PRE_JOINED：榜单文案 + 广播提示文案（交替）
 * - ON_PROGRESS：榜单文案 + 可绑定业务线文案（交替）
 * - 其他状态：仅榜单文案
 */
export function resolveNoticeItems(status, leaderboardItems, canBindBizLines, feConfig) {
    const leaderboardTexts = leaderboardItems.map(item => `${item.userName}用户已邀请${item.invitedCount}位好友获得 ${((item.cashBackAmount ?? 0) / 100).toFixed(2)} 元免单卡`);
    if (status === ActivityStatus.PRE_JOINED) {
        // 与 ON_PROGRESS 同构：轮播插入免单卡可核销业务线（前后缀来自运营配置，业务线来自后端 canBindBizLines）；
        // 后端未下发业务线时用运营配置的兜底文案。
        const prefix = feConfig.preJoinedConfig?.broadcastPrefix ?? '';
        const suffix = feConfig.preJoinedConfig?.broadcastSuffix ?? '';
        const fallback = feConfig.preJoinedConfig?.broadcastFallbackText ?? '请注意，该免单卡仅可在锁定目的地城市内使用';
        const broadcast = canBindBizLines.length > 0 ? `${prefix}${canBindBizLines.map(line => OnProgressBizLineDesc?.[line] ?? String(line)).join('、')}${suffix}` : fallback;
        return mergeItems(leaderboardTexts, [broadcast]);
    }
    if (status === ActivityStatus.ON_PROGRESS) {
        // 轮播插入可绑定业务线（前后缀来自运营配置，业务线来自后端 canBindBizLines）；
        // 后端未下发业务线时用运营配置的兜底文案。
        const prefix = feConfig.onProgressConfig?.broadcastPrefix ?? '';
        const suffix = feConfig.onProgressConfig?.broadcastSuffix ?? '';
        const fallback = feConfig.onProgressConfig?.broadcastFallbackText ?? '城市住行玩免单卡，多业务可核销';
        const broadcast = canBindBizLines.length > 0 ? `${prefix}${canBindBizLines.map(line => OnProgressBizLineDesc?.[line] ?? String(line)).join('、')}${suffix}` : fallback;
        return mergeItems(leaderboardTexts, [broadcast]);
    }
    return leaderboardTexts;
}
